/* eslint-disable react/no-multi-comp */
import { t } from 'i18next';

import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';

import { MASH_SUBSTEPS_IDS } from './constants';
import styles from './styles.module.scss';

export const MASHING_AND_COLLECTION_TITLES = {
  key: 'titles',
  Component: AdelphiFieldsRow,
  fieldContainerClassName: styles.mashingAndCollectionTableColumns,
  fields: [
    {
      key: 'waterNo',
      Component: () => (
        <span className={styles.mashingTitle}>
          {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:waterNo`)}
        </span>
      )
    },
    {
      key: 'spoutTemp',
      Component: () => (
        <span className={styles.mashingTitle}>
          {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:spoutTemp`)}
        </span>
      )
    },
    {
      key: 'litres',
      Component: () => (
        <span className={styles.mashingTitle}>{t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:litres`)}</span>
      )
    },
    {
      key: 'timeMashInSpargeOn',
      Component: () => (
        <span className={styles.mashingTitle}>
          {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:timeMashInSpargeOn`)}
        </span>
      )
    },
    {
      key: 'settlingTime',
      Component: () => (
        <span className={styles.mashingTitle}>
          {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:settlingTime`)}
        </span>
      )
    },
    {
      key: 'recirculationTime',
      Component: () => (
        <span className={styles.mashingTitle}>
          {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:recirculationTime`)}
        </span>
      )
    },
    {
      key: 'startDrainTime',
      Component: () => (
        <span className={styles.mashingTitle}>
          {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:startDrainTime`)}
        </span>
      )
    },
    {
      key: 'timeDrained',
      Component: () => (
        <span className={styles.mashingTitle}>
          {t(`${MASH_SUBSTEPS_IDS.MASHING_AND_COLLECTION}:timeDrained`)}
        </span>
      )
    }
  ]
};
